export default __webpack_public_path__ + "static/ff53be97a0e32d22c2a3c1c1f16727b4.ttf";